module.exports = __webpack_public_path__ + "static/media/vegan.f1aa10f1.jpg";